export enum EAssemblyOrderAgField {
  ID = 'id',
  STATUS = 'status',
  RFQ_ID = 'rfqId',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  PLANNED_QUANTITY = 'plannedQuantity',
  ACTUAL_QUANTITY = 'actualQuantity',
  AGE = 'age',
  PRODUCT_NAME = 'rfq.productName',
  INTERNAL_SKU = 'rfq.internalSku',
  ACTIONS = 'actions',
  ORDER_TYPE = 'type',
  ALTERNATE_IDS = 'alternateIds',
}

export interface IAssemblyOrderFilterParams {
  orderId ?:string;
  internalSku ?:string;
  productName ?:string;
  age ?:string;
  startTime ?:string;
  endTime ?:string;
  orderStatus ?:string;
  plannedQuantityRange ?:string;
  actualQuantityRange ?:string;
  type ?:string;
  alternateId ?:string;
}

export enum EAssemblyOrderStatus {
  IN_PROGRESS = 'in_progress',
  DRAFT = 'draft',
  ISSUED = 'issued',
  PAUSED = 'paused',
  COMPLETED = 'completed',
}

export enum EAssemblyOrderType {
  ASSEMBLY = 'assembly',
  DISASSEMBLY = 'disassembly',
}

export enum EAssemblyOrderStatusValue {
  OPEN = 'open',
  CLOSED = 'closed',
}
